export default __webpack_public_path__ + "static/media/blue.a7dc728d.svg";